import { createContext } from 'react';

export const RouteLoadingContext = createContext(false);
